<template>
  <dialog-v2
    :show="show"
    :disableSaveBtn="!canSave"
    :title="title"
    max-width="450px"
    @close="$emit('close')"
    @save="save"
  >
    <template slot="content">
      <v-layout row wrap>
        <template v-if="!isPaymentType && isNewWorkflow">
          <v-flex xs4>
            <v-text-field
              :disabled="!isInRelease"
              class="w-100 px-2"
              label="Cant Intentos"
              v-model="form.attemps_g5"
              v-validate="'required|integer'"
              data-vv-name="attemps_g5"
              data-vv-scope="filter"
              data-vv-as="ventana de tiempo whatsapp"
              color="black"
              :error-messages="errors.collect('attemps_g5')"
            />
          </v-flex>
          <v-flex xs4>
            <v-text-field
              :disabled="!isInRelease"
              class="w-100 px-2"
              label="V Intentos"
              v-model="form.days_off_attemps_g5"
              v-validate="'required|integer'"
              data-vv-name="days_off_attemps_g5"
              data-vv-scope="filter"
              data-vv-as="ventana de tiempo whatsapp"
              color="black"
              :error-messages="errors.collect('days_off_attemps_g5')"
            />
          </v-flex>
          <v-flex xs4>
            <v-text-field
              class="w-100 px-2"
              label="V contacto"
              v-model="form.days_off_g5"
              v-validate="'required|integer'"
              data-vv-name="days_off_g5"
              data-vv-scope="filter"
              data-vv-as="ventana de tiempo whatsapp"
              color="black"
              :error-messages="errors.collect('days_off_g5')"
            />
          </v-flex>
        </template>
        <v-flex v-if="collyRequestError" xs12>
          <p class="mb-0 red--text text--darken-2">{{ collyRequestError }}</p>
        </v-flex>
        <v-flex v-if="collyRelease.whatsapp" xs12>
          <v-select
            v-model="form.colly_whatsapp_sender_id"
            :items="[{ id: null, display_name: 'Por defecto' }].concat(collyWhatsappNumbers)"
            :loading="collySendersLoading"
            :disabled="collySendersLoading"
            class="w-100"
            item-value="id"
            item-text="display_name"
            label="Teléfono"
            color="black"
            @input="loadCollyTemplates"
          />
          <p v-if="senderLookupError" class="mb-0 red--text text--darken-2">{{ senderLookupError }}</p>
        </v-flex>
        <v-flex xs12>
          <v-select
            v-if="collyRelease.whatsapp"
            v-model="form.colly_whatsapp_template_id"
            :items="whatsappTemplates"
            :loading="loadingTemplates"
            :disabled="loadingTemplates"
            no-data-text="Sin plantillas compatibles con el teléfono"
            item-value="id"
            item-text="display_name"
            data-vv-name="whatsapp_template_id"
            data-vv-scope="whatsappTemplate"
            data-vv-as="plantilla"
            label="Nombre"
            color="black"
            :error-messages="errors.collect('whatsappTemplate.whatsapp_template_id')"
          />
          <v-select
            v-else
            v-model="form.whatsapp_template_id"
            :items="whatsappTemplates"
            :loading="loadingTemplates"
            :disabled="loadingTemplates"
            item-value="id"
            item-text="display_name"
            data-vv-name="whatsapp_template_id"
            data-vv-scope="whatsappTemplate"
            data-vv-as="plantilla"
            label="Nombre"
            color="black"
            :error-messages="errors.collect('whatsappTemplate.whatsapp_template_id')"
          >
            <template slot="selection" slot-scope="data">
              <span class="mr-2">{{ data.item.display_name }}</span>
              <v-chip
                v-if="data.item && !data.item.isApproved"
                small
                :color="data.item.statusColor"
                :text-color="data.item.statusTextColor"
              >
                {{ data.item.statusLabel }}
              </v-chip>
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title>{{ data.item.display_name }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-chip
                  small
                  :color="data.item.statusColor"
                  :text-color="data.item.statusTextColor"
                >
                  {{ data.item.statusLabel }}
                </v-chip>
              </v-list-tile-action>
            </template>
          </v-select>
        </v-flex>
        <v-flex v-if="!collyRelease.whatsapp && selectedTemplate && !selectedTemplate.isApproved" xs12>
          <p class="mb-0 red--text text--darken-2">
            La plantilla seleccionada no está aprobada. Elija otra plantilla para guardar.
          </p>
        </v-flex>
        <v-flex v-if="isNewWorkflow" xs12>
          <v-select
            v-model="form.whatsapp_owner_id"
            :items="phoneOwners"
            class="w-100"
            item-value="id"
            item-text="name"
            label="Tipo de teléfono"
            color="black"
          />
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import DialogV2 from '@/components/global/DialogV2';
import { fetchWhatsappTemplatesForSelect } from '@/mixins/whatsappTemplateSelect';

const EMPTY_FORM = {
  whatsapp_template_id: null,
  colly_whatsapp_template_id: null,
  colly_whatsapp_sender_id: null,
  whatsapp_owner_id: null,
  days_off_g5: null,
  days_off_attemps_g5: null,
  attemps_g5: null,
};

export default {
  inject: {
    $validator: '$validator',
    // Lo provee la página del flujo de cobranza (carga el release una vez).
    collyRelease: { default: () => ({}) },
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    workflowFilter: {
      type: Object,
      default: () => ({}),
    },
    isPaymentType: {
      type: Boolean,
      default: false,
    },
    isInRelease: {
      type: Boolean,
      default: false,
    },
    isNewWorkflow: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DialogV2,
  },
  data() {
    return {
      whatsappTemplates: [],
      loadingTemplates: false,
      collyWhatsappNumbers: [],
      collySendersLoading: false,
      senderLookupError: '',
      collyRequestError: '',
      form: {
        ...EMPTY_FORM,
      },
      phoneOwners: [
        {
          id: 1,
          name: 'Titular',
        },
        {
          id: 2,
          name: 'Tercero',
        },
        {
          id: null,
          name: 'Todos los teléfonos',
        },
      ],
    };
  },
  computed: {
    selectedTemplate() {
      return this.whatsappTemplates.find(template => template.id === this.form.whatsapp_template_id) || null;
    },
    canSave() {
      if (this.collyRelease.whatsapp) {
        return !!this.form.colly_whatsapp_template_id
          && !this.collyRequestError
          && !this.senderLookupError
          && !this.collySendersLoading
          && !this.loadingTemplates;
      }
      return !!this.selectedTemplate && this.selectedTemplate.isApproved;
    },
    title() {
      if (this.isNewWorkflow) {
        return 'Ajustes de canal whatsapp';
      }
      return 'Seleccione una plantilla';
    },
  },
  methods: {
    mapCollyTemplates(items) {
      return items.map((template) => ({
        ...template,
        display_name: template.name,
      }));
    },
    mapCollyNumbers(raw) {
      const list = Array.isArray(raw) ? raw : (raw && (raw.items || raw.data)) || [];
      if (!Array.isArray(list)) {
        return [];
      }
      return list.map((item) => ({
        ...item,
        id: item.senderId || item.sid,
        display_name: item.address || item.name || item.senderId || item.sid,
      }));
    },
    collyRequestErrorMessage(error) {
      const response = error && error.response;
      const data = response && response.data;
      const status = response && response.status;
      let detail = '';
      if (data && typeof data === 'object') {
        try {
          detail = JSON.stringify(data);
        } catch (err) {
          detail = '';
        }
      } else if (typeof data === 'string') {
        const trimmed = data.replace(/\s+/g, ' ').trim();
        if (trimmed && trimmed.charAt(0) !== '<') {
          detail = trimmed.slice(0, 500);
        }
      }
      const statusText = status ? ` (${status})` : '';
      return detail
        ? `La petición a Colly falló${statusText}. ${detail}`
        : `La petición a Colly falló${statusText}.`;
    },
    async loadWhatsappTemplates() {
      this.loadingTemplates = true;
      try {
        this.whatsappTemplates = await fetchWhatsappTemplatesForSelect(this.axios);
      } catch (e) {
        this.whatsappTemplates = [];
      } finally {
        this.loadingTemplates = false;
      }
    },
    async loadCollySenders() {
      this.collySendersLoading = true;
      this.senderLookupError = '';
      try {
        const { data } = await this.axios.get('whatsapp_templates/colly/numbers', {
          params: { channel: 'whatsapp' },
        });
        this.collyWhatsappNumbers = this.mapCollyNumbers(data);
      } catch (e) {
        this.collyWhatsappNumbers = [];
        this.senderLookupError = this.collyRequestErrorMessage(e);
      } finally {
        this.collySendersLoading = false;
      }
      const senderId = this.form.colly_whatsapp_sender_id;
      const exists = this.collyWhatsappNumbers.some(item => item.id === senderId);
      if (!senderId || exists) {
        return;
      }
      // El teléfono guardado ya no está: queda "Por defecto" con las plantillas de todo el canal.
      this.form.colly_whatsapp_sender_id = null;
      this.loadCollyTemplates();
    },
    async loadCollyTemplates() {
      const senderId = this.form.colly_whatsapp_sender_id;
      this.loadingTemplates = true;
      this.collyRequestError = '';
      // Sin teléfono ("Por defecto") axios omite compatibleWith: todas las plantillas del canal.
      const response = await this.axios.get('whatsapp_templates', {
        params: { paginate: 0, compatibleWith: senderId },
      }).catch(error => ({ error }));
      // El teléfono cambió mientras cargaba: vale la respuesta del último.
      if (senderId !== this.form.colly_whatsapp_sender_id) {
        return;
      }
      this.loadingTemplates = false;
      if (response.error) {
        this.whatsappTemplates = [];
        this.form.colly_whatsapp_template_id = null;
        this.collyRequestError = this.collyRequestErrorMessage(response.error);
        return;
      }
      this.whatsappTemplates = this.mapCollyTemplates((response.data && response.data.items) || []);
      const templateId = this.form.colly_whatsapp_template_id;
      if (!this.whatsappTemplates.some(template => template.id === templateId)) {
        this.form.colly_whatsapp_template_id = null;
      }
    },
    save() {
      this.$validator.validateAll('whatsappTemplate').then((validation) => {
        if (validation && this.canSave) {
          const payload = { ...this.form };
          if (this.collyRelease.whatsapp) {
            // Sin la clave: un null en el PATCH borraría la plantilla legacy (fill del API).
            delete payload.whatsapp_template_id;
          } else {
            payload.colly_whatsapp_template_id = null;
            payload.colly_whatsapp_sender_id = null;
          }
          this.$emit('save', payload);
          this.$emit('close');
        }
      });
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.form = {
          ...EMPTY_FORM,
          ...this.workflowFilter,
        };
        if (this.collyRelease.whatsapp) {
          this.loadCollySenders();
          this.loadCollyTemplates();
          return;
        }
        this.loadWhatsappTemplates();
      } else {
        this.form = {
          ...EMPTY_FORM,
        };
        this.whatsappTemplates = [];
        this.collyWhatsappNumbers = [];
        this.collySendersLoading = false;
        this.senderLookupError = '';
        this.collyRequestError = '';
        this.$validator.errors.remove('whatsapp_template_id', 'whatsappTemplate');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/Detail/WorkflowTree/WhatsappTemplates.vue